import HamburgerMenuIcon from 'src/images/icons/HamburgerMenuIcon'

import type { SidebarMenuProps } from '../SideBarMenu'
import { ButtonIcon } from '../../ButtonIcon'

interface OpenMenuButtonProps extends SidebarMenuProps {
  onClick: () => void
  showTitle?: boolean
}

const OpenMenuButton = ({
  onClick,
  badgeConfig,
  showTitle = true,
}: OpenMenuButtonProps) => {
  return (
    <div>
      <div className="w-12 h-9 bg-white flex items-center justify-center">
        <ButtonIcon
          aria-label="botão abrir menu mobile"
          enableHover
          onClick={onClick}
          {...badgeConfig}
        >
          <div className="flex-column items-center">
            <HamburgerMenuIcon />
            {showTitle && (
              <p className="mt-[6px] font-inter font-semibold text-[8px] leading-[100%] tracking-[0px] text-center">
                Menu
              </p>
            )}
          </div>
        </ButtonIcon>
      </div>
    </div>
  )
}

export default OpenMenuButton
